import { Command } from '@nest/internal-frontend';
import { ListIcon } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useNumberParam } from '../../../helpers';

export const useCommandOpenPackedNotInContainerListPage = (): Command => {
	const navigate = useNavigate();
	const carrierId = useNumberParam('carrierId');

	return {
		id: 'open-packed-not-in-container-list',
		label: 'Zabalené mimo kontejnery',
		icon: <ListIcon className="h-4 w-4" />,
		shortcut: undefined,
		disabled: !carrierId,
		loading: undefined,
		run: async () => {
			if (carrierId) {
				navigate(`/consignment-notes/carriers/${carrierId}/packed-not-in-container`);
			}
		}
	};
};
